import { useEffect } from "react";

// Warns the user before they leave with unsaved edits (tab close, refresh, hard
// navigation). Forms already persist only on Save; this guards accidental loss.
export function useUnsavedChanges(dirty) {
  useEffect(() => {
    if (!dirty) return undefined;
    const handler = (e) => {
      e.preventDefault();
      e.returnValue = "Your changes won't be saved because you didn't click Save.";
      return e.returnValue;
    };
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [dirty]);
}
